import React, { useEffect } from "react";
import {
  ImageList,
  ImageListItem,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Box,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "src/store";
import { fetchTalentsAsync } from "src/features/talents/talentsSlice";
import { fetchPositions } from "src/features/positionsSlice";
import { Talent } from "src/features/talents/talentsTypes";
import TalentTableList from "src/components/talent/TalentTableList";
import CompanyTable from "src/components/company/CompanyTable";
import { useTranslation } from "react-i18next";

const HomeContent: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const { talents } = useSelector((state: RootState) => state.talents);
  const { positions } = useSelector((state: RootState) => state.positions);
  const { token, user } = useSelector((state: RootState) => state.auth);
  const companyId =
    user?.accountType === "company"
      ? (user.companyId || user.id || user.userId || "")
      : "";

  useEffect(() => {
    if (!token || !companyId) return;
    dispatch(fetchPositions());
  }, [dispatch, token, companyId]);

  useEffect(() => {
    if (!positions.length) return;
    const firstPosition = positions[0];
    dispatch(
      fetchTalentsAsync({
        positionId: firstPosition.id,
        positionTitle: firstPosition.jobTitle,
      })
    );
  }, [dispatch, positions]);

  const handleRowClick = (talent: Talent, index: number) => {
    console.log("Clicked talent:", talent);
  };

  return (
    <>
    <ImageList variant="masonry" cols={2} gap={8} sx={{ p: 6 }}>
      <ImageListItem>
        <Card>
          <CardHeader py={50} title={t("home.notifications.title")} />

          <CardContent>
            <Typography>{t("home.notifications.empty")}</Typography>
            <Typography color="textSecondary">
              {t("home.notifications.description")}
            </Typography>
          </CardContent>
        </Card>
      </ImageListItem>
      <ImageListItem>
        <Card>
          <CardHeader>
            <Typography>{t("home.teamPerformance.title")}</Typography>
          </CardHeader>
          <CardContent>
            <Typography>{t("home.teamPerformance.empty")}</Typography>
            <Typography color="textSecondary">
              {t("home.teamPerformance.description")}
            </Typography>
          </CardContent>
        </Card>
      </ImageListItem>
      <ImageListItem>
        <Card>
          <CardHeader title={t("home.recentActions")} />
          <CardContent>
            <Typography variant="h6">{t("home.candidates")}</Typography>
            <Typography>Olcay Ozdemir</Typography>
            <Typography variant="h6" sx={{ mt: 2 }}>
              {t("home.jobs")}
            </Typography>
            <Typography>Frontend Developer</Typography>
          </CardContent>
        </Card>
      </ImageListItem>
      <ImageListItem>
        <Card>
          <CardHeader title={t("home.myActivities")} />
          <CardContent>
            <Typography>{t("home.activitiesEmpty")}</Typography>
          </CardContent>
        </Card>
      </ImageListItem>
      <ImageListItem>
        <Card>
          <CardHeader title={t("home.myPerformance")} />
          <CardContent>
            <Typography variant="h6">{t("home.myCandidates")}</Typography>
            <Typography variant="h6" sx={{ mt: 2 }}>
              {t("home.myJobs")}
            </Typography>
          </CardContent>
        </Card>
      </ImageListItem>
    </ImageList>

    <Box sx={{ mt: 4, pl: 6, pr: 6 }}>
      <Typography variant="h5" gutterBottom>{t("home.talentList")}</Typography>
      <TalentTableList talents={talents} onRowClick={handleRowClick} />
    </Box>

    <Box sx={{ mt: 4, pl: 6, pr: 6, pb: 4 }}>
      <Typography variant="h5" gutterBottom>{t("home.companyList")}</Typography>
      <CompanyTable />
    </Box>
  </>
  );
};

export default HomeContent;
